module.exports = __webpack_public_path__ + "static/media/Compras4.0f25a240.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras4.png
// module id = 2070
// module chunks = 0